module.exports = __webpack_public_path__ + "static/media/white-play-button.f56bd02b.svg";